import React, { useState, useCallback, ReactElement } from 'react';
import * as css from './Contracts.module.scss';
import 'src/css/themes.scss';
import ContractsPanel from 'src/components/ConnectedVehicle/Contracts/ContractsPanel/containers/ContractsPanel';
import { IconSeeMore } from 'src/content/icons';
import { ConnectedVehicleRec } from 'src/models';
import { Dialog } from '@framework-controls/core';
import { strings } from 'src/localization';
import { random } from 'lodash';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
}

const Contracts = (props: IProps) => {
    const [contractsOpen, setContractsOpen] = useState(false);
    const toggleContracts = useCallback(() => {
        setContractsOpen(!contractsOpen);
    }, [contractsOpen]);

    let mcArea: ReactElement[] | null = null;
    if (props.connectedVehicle.mc && props.connectedVehicle.mc.length > 0) {
        mcArea = props.connectedVehicle.mc.map((mc, index) => <ContractsPanel
            key={random(99999)}
            index={index}
            type='mc'
        />);
    }

    let acArea: ReactElement[] | null = null;
    if (props.connectedVehicle.ac && props.connectedVehicle.ac.length > 0) {
        acArea = props.connectedVehicle.ac.map((ac, index) => <ContractsPanel
            key={random(99999)}
            index={index}
            type='ac'
        />);
    }

    let xcArea: ReactElement[] | null = null;
    if (props.connectedVehicle.xc && props.connectedVehicle.xc.length > 0) {
        xcArea = props.connectedVehicle.xc.map((xc, index) => <ContractsPanel
            key={random(99999)}
            index={index}
            type='xc'
        />);
    }

    return (
        <div>
            <span className={css.header}>
                <div className={css.headerLit}>{strings.MaintenanceContracts}</div>
                <div className={css.icon}>
                    <IconSeeMore onClick={() => toggleContracts()} />
                </div>
            </span>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={contractsOpen}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={strings.MaintenanceContracts.toUpperCase()}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={() => toggleContracts()}
                onBackDropClick={() => toggleContracts()}
                width={'full'}
            >
                <div className={css.mc}>
                    {mcArea}
                    {acArea}
                    {xcArea}
                </div>
            </Dialog>
        </div>
    );
};

export default Contracts;